import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        sites: '<',
        trainers: '='
    },
    template: `
    <div class="col00">
        <div class="heading01 type01">
            <h1>{{ 'validations.List of validations' | translate }}</h1>
        </div>
        <forms-validations-filter
            trainers="vm.trainers"
            sites="vm.sites"
            list="vm.list"
            filter="vm.filter"
            default-query="vm.defaultQuery"
        />
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <pagination-tools list="vm.list"></pagination-tools>
            <table class="data01">
                <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('userId')"><a ng-click="vm.list.sortBy('userId')">{{ 'courses.Employee' | translate }}</a></th>
                        <th ng-class="vm.list.getSortClass('courseId')"><a ng-click="vm.list.sortBy('courseId')">{{ 'course.Course' | translate }}</a></th>
                        <th>{{ 'occurrence.Collected points' | translate }}</th>
                        <th ng-class="vm.list.getSortClass('status')"><a ng-click="vm.list.sortBy('status')">{{ 'course.Status' | translate }}</a></th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="form in vm.list.items">
                        <td>{{ form.user.displayName }}</td>
                        <td>{{ form.occurrence.course.activeI18n.name }}</td>
                        <td>{{ vm.getCollectedPoints(form) }}</td>
                        <td>{{ vm.COURSE_TRAINING_STATUS_TYPE_ENUM.LABELS[form.status] }}</td>
                        <td class="actions">
                            <a ui-sref="authorized.forms.validations.detail({ id: form.id })" class="btn view">{{ 'general.View' | translate }}</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    </div>
    `
})
export default class {
    constructor ($translate, ListFactory, ModalService, lodash, TrainingProgressResource, DATATABLES, COURSE_TRAINING_STATUS_TYPE_ENUM) {
        this.$translate = $translate;
        this.TrainingProgressResource = TrainingProgressResource;
        this.ListFactory = ListFactory;
        this.DATATABLES = DATATABLES;
        this.COURSE_TRAINING_STATUS_TYPE_ENUM = COURSE_TRAINING_STATUS_TYPE_ENUM;
        this.ModalService = ModalService;
        this.lodash = lodash;

        this.defaultQuery = { expand: 'user,occurrence.course.activeI18n,formSubmission' };
        this.filter = lodash.assign({}, this.defaultQuery);
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.TrainingProgressResource.getProgresses.bind(this.TrainingProgressResource));
        this.list.pagination.perPage = 25;
    }

    getCollectedPoints (item) {
        if (!item.formSubmission) {
            return '- / -';
        }

        let totalPoints = (item.formSubmission.totalPoints || item.formSubmission.totalPoints === 0) ? item.formSubmission.totalPoints : '-';
        if (totalPoints < 0) {
            totalPoints = 0;
        }

        const maxScore = item.formSubmission.maxScore ? item.formSubmission.maxScore : '-';
        return `${totalPoints} / ${maxScore}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/validations/list/index.js